<!-- <div class="container container-cart site_b2c">
  <div class="row justify-content-md-center mt-5">
    <div class="col-6sb mx-auto mb-3">
      <div
        appDragDrop
        class="block-drop-down-file mx-auto flex align-items-center justify-content-center"
      >
        <input hidden type="file" #fileInput />

        <div class="block text-center">
          <i class="fas fa-check-circle mb-3"></i>
          <h1>¡Cotización generada!</h1>
          <h1>{{ numero }}</h1>

          <p>Muchas gracias por visitar {{ config.url }}</p>

          <a
            class="mt-3 link-primary"
            routerLink="/carro-compra/downloadpdf"
            [queryParams]="{ numero: numero }"
          >
            <i class="far fa-file-pdf"></i>
            Descargar Cotización
          </a>

          <a
            routerLink="/mi-cuenta/cotizaciones"
            class="mt-5 link-primary w-100 text-center"
          >
            <i class="fas fa-file-invoice"></i>
            Ver mis cotizaciones
          </a>

          <a
            [routerLink]="['/', 'inicio']"
            class="mt-5 link-primary w-100 text-center"
          >
            <i class="fas fa-home"></i>
            Ir al home
          </a>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- Version primeng  -->
<div class="flex justify-content-center pt-6">
  <div class="md:col-8 sm:col-12 lg:col-6 xl:col-6 p-1 md:p-0"  >
    <p-card class="">
      <ng-template pTemplate="content">
        <div class="text-center">
          <i class="fas fa-check-circle mb-3 green-icon"></i>
          <h1 class="green-text text-3xl" >¡Cotización generada!</h1>
          <h1 class="green-text text-3xl" >{{ numero }}</h1>
          <p class="md:px-8 px-3 mb-0" >
            Revisa tu cotización haciendo clic en el botón de abajo o accediendo al módulo 'Cotización' dentro de tu perfil cuando lo desees
          </p>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="flex gap-1">
          <p-button class="w-4 p-0" size="small" routerLink="/carro-compra/downloadpdf"
          [queryParams]="{ numero: numero }">
            <div class="flex flex-column">
              <i class="pi pi-file-pdf"></i>
              <span class="px-1">Descargar cotización</span>
            </div>
          </p-button>
          <p-button class="w-4 p-0" size="small" routerLink="/mi-cuenta/cotizaciones">
            <div class="flex flex-column">
              <i class="pi pi-file"></i>
              <span class="px-1">Ver mis cotizaciones</span>
            </div>
          </p-button>
          <p-button class="w-4 p-0" size="small" [routerLink]="['/', 'inicio']">
            <div class="flex flex-column">
              <i class="pi pi-home"></i>
              <span class="px-1">Ir al home</span>
            </div>
          </p-button>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>


